const doctorFAQsAPI = [
  {
    id: "collapseOne",
    question: "How do I join NirogSathi as a doctor?",
    answer: `Joining NirogSathi is easy. Simply click on the "Join for Free" button and fill out the registration form. Our team will guide you through the rest.`,
  },

  {
    id: "collapseTwo",
    question: "How can NirogSathi help me manage my practice?",
    answer: `NirogSathi provides tools for appointment scheduling, patient management, and telemedicine, helping you streamline your practice efficiently.`,
  },

  {
    id: "collapseThree",
    question: "Is my information secure on NirogSathi?",
    answer: `Yes, we use state-of-the-art security measures to ensure that your personal and professional information is protected.`,
  },
  {
    id: "collapseFour",
    question: "Can I see and manage my patient reviews?",
    answer: `Yes, you can view and manage patient reviews to maintain a positive online reputation.`,
  },
  {
    id: "collapseFive",
    question: "Does NirogSathi support telemedicine?",
    answer: `Absolutely, NirogSathi offers telemedicine services allowing you to consult with patients remotely.`,
  },
  {
    id: "collapseSix",
    question: "What happens if I need to cancel an appointment?",
    answer: `You can easily manage or cancel appointments through our platform. Patients will be notified of any changes.`,
  },
  {
    id: "collapseSeven",
    question: "How do I contact NirogSathi support?",
    answer: `You can reach our support team via email at nirogsathi@gmail.com or call us at +91 12345 54321.`,
  },
];

export default doctorFAQsAPI;
